import { createFileRoute, useNavigate } from '@tanstack/react-router';
import ApplicationOverview from '../../../components/navigation/ApplicationOverview';
import { useAuth } from '../../../contexts/AuthContext';
import usePatientDoc from '../../../hooks/usePatientDoc';
import useChart from '../../../hooks/useChart';
import { PatientDoc } from '@usacsmideo/types';
import { classNames } from '../../../style/classNames';
import { useNavObjVersionUpdate } from '../../../hooks/useNavObjVersionUpdate';

export const Route = createFileRoute('/_authenticated/$patientId/')({
  component: Index,
});

function Index() {
  const { currentUser } = useAuth();
  const patientId = currentUser?.uid || '';
  const chartQuery = useChart(patientId);
  const chartHasResolved = chartQuery.hasResolved;
  const patientDocQuery = usePatientDoc(patientId);
  const patientInfo = patientDocQuery.data as PatientDoc;
  const navigate = useNavigate();

  // KEEP NAV OBJECT UP-TO-DATE (CU-17tm466h63q). One guarded CF call per stale
  // version; the server writes the reconciled navObj, so there is no client
  // write here. Gated on the chart, as before (D5). Missing-navObj recovery
  // lives in the _authenticated/$patientId.tsx layout (CU-86ahkkbmb W1).
  useNavObjVersionUpdate({ patientId, patientInfo, enabled: chartHasResolved });

  if (!patientInfo) return <>Loading...</>;
  return (
    <>
      {patientInfo?.completedOnboarding && <ApplicationOverview patientId={patientId} />}
      {(patientInfo?.completedOnboarding === undefined || patientInfo.completedOnboarding === false) && (
        <div className="flex flex-col items-center justify-center px-4">
          <div className="my-8 w-5/12">
            <img src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png" alt="mideo_logo" />
          </div>
          <p className="text-mideo-darkred my-4 text-center text-4xl font-bold">Welcome to MIDEO Health</p>
          {/* TODO: Add captions track and disable warning */}
          {/* eslint-disable-next-line */}
          <video id="patient-education-video" className="w-2/3" controls>
            <source
              src="https://storage.googleapis.com/mideoid-console-public/videos/instructional/en/patientOverview.mp4"
              type="video/mp4"
            />
          </video>
          <p className="text-mideo-darkred mt-8 mb-6 text-center text-2xl font-bold text-gray-600">
            Before you begin, we need some information about you to tailor your experience in the app.
          </p>
          <button
            className={classNames.nextButton}
            onClick={() => {
              navigate({ to: '/$patientId/onboarding', params: { patientId } });
            }}
          >
            Get Started
          </button>
        </div>
      )}
    </>
  );
}

export default Index;
